<template>
	<div class="infoBox" :class="type">
		<div class="infoboxicon">
			<div class="icon" v-if="type==='confirm'">
				<!-- SVG -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
				<circle class="icon_circle" cx="24" cy="24" r="22" />
				<path class="icon_symbol" d="M15,15.7c0.9,0.3,6.7,10.4,7.3,11.1c1.3-1,10.1-14.1,11.1-14.2c0.9,0,3.6,3.4,3.6,4.3
				C37,17.6,22.8,37,21.8,37c-1,0-11.3-18-11.5-18.7C10.5,17.4,14.3,15.4,15,15.7z" />
			</svg>
		</div>
		<div class="icon" v-if="type==='info'">
			<!-- SVG -->
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
			<circle class="icon_circle" cx="24" cy="24" r="22" />
			<path class="icon_symbol" d="M19,19.1c-0.2,0.8-0.4,0.8-0.2,1.4c0.1,0.2,0.3,1.7,0.6,1.7c0,0,2.3-0.3,2.6-0.2c-0.2,3.4-0.1,5.9,0.1,9.6
			c0,0.3-0.2,0.4-0.5,0.5c-1.3,0.2-2.4,0.4-3.5,0.6c-0.2,0.1-0.4,0.2-0.4,0.4c-0.2,1.3-0.3,2.6,0,3.8c0.1,0.3,0.4,0.5,0.7,0.4
			c4.2-0.7,8.6-1,13.2-0.9c0.2,0,0.5-0.1,0.6-0.3c0.4-1.1,0.6-2.3,0.7-3.5c0-0.3-0.2-0.6-0.6-0.6c-1,0-2.2-0.1-3.5-0.1
			c-0.3,0-0.6-0.3-0.6-0.6c-0.4-5.1-0.4-10.7-0.5-13.3c0-0.3-0.3-0.5-0.6-0.5c-3.1,0.1-6,0.2-7.6,0.8C19.2,18.8,19.1,18.9,19,19.1z" />
			<path class="icon_symbol" d="M22.5,14.8l4.4,0c0.2,0,0.5-0.2,0.5-0.4c0.2-1.1,0.1-2.3,0-3.6c0-0.2-0.2-0.4-0.4-0.5c-1.6-0.2-3-0.3-4.1-0.2
			c-0.2,0-0.4,0.2-0.5,0.4c-0.2,1.3-0.3,2.5-0.4,3.7C22,14.6,22.2,14.8,22.5,14.8z" />
		</svg>
	</div>
	<div class="icon" v-if="type==='warning'">
		<!-- SVG -->
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
		<circle class="icon_circle" cx="24" cy="24" r="22" />
		<path class="icon_symbol" d="M21.4,11.5C21,12.6,20.9,29,21.3,30c0.9,0.5,5.2-0.3,5.8-0.6c0,0.2,0.3-16.9,0.3-18
		C26.9,11,21.9,11.2,21.4,11.5z" />
		<path class="icon_symbol" d="M21.5,33.3c-0.1,0.3,0.2,3.1,0.4,3.5c1.3,0.5,5-0.1,5.5-0.4c0.1-0.4,0.1-3.3-0.1-4.2
		C27,32,22.1,32.7,21.5,33.3z" />
	</svg>
</div>
<div class="icon" v-if="type==='alert'">
	<!-- SVG -->
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
	<circle class="icon_circle" cx="24" cy="24" r="22" />
	<path class="icon_symbol" d="M37,13c0-0.8-4.2-2-5.2-2c-1.2,0.1-7.6,8.7-8.5,9.3c-0.7-0.7-5.5-7.4-6.5-7.4c-0.8-0.1-4.8,1-5,1.8
	c0.1,0.4,4.3,5.6,7.9,9.8C13.9,30.8,11,34.5,11,35c0,0.8,4.2,2,5.2,2c1.2-0.1,6.5-7.9,7.5-8.5c0.7,0.7,6.5,8.1,7.6,8.1
	c0.9,0,4.8-1.1,5.1-1.9c-0.2-0.4-5.4-6.3-9-10.4C33,17.9,37,13.5,37,13z" />
</svg>
</div>
</div>
<div class="infoboxcontent">
	<slot></slot>
</div>
</div>
</template>

<!-- ================================================================================== -->

<script>
	export default {
		name:"Info Box",
		props: {
			type: {
				type: String,
				required: true,
				default: 'info'
			}
		},
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>

</style>
